import { ConfinusUI__Forms__CheckboxControllerIdentifier } from "controllers/identifiers";
import CheckboxController from "confinus_ui/forms/checkbox_controller";
import FormFieldController from "confinus_ui/forms/form_field_controller";

export default class ExpandingCheckboxCollectionController extends FormFieldController {
  public static outlets = [ConfinusUI__Forms__CheckboxControllerIdentifier];
  declare private readonly confinusUiFormsCheckboxOutlets: CheckboxController[];
  private get checkboxControllers() {
    return this.confinusUiFormsCheckboxOutlets;
  }

  public static targets = ["showMoreLink"];

  public static values = {
    ...FormFieldController.values,
    required: Boolean,
  };

  declare private readonly showMoreLinkTarget: HTMLElement;
  declare private readonly requiredValue: boolean;

  private showingMore = false;

  public connect() {
    super.connect();
    this.checkboxControllers.forEach((checkbox) => {
      if (checkbox.checked && checkbox.element.classList.contains("hideable")) {
        checkbox.element.classList.remove("hidden");
      }
    });
  }

  public validate() {
    if (!this.requiredValue) {
      return {
        errors: [],
        valid: true,
      };
    }
    return {
      errors: [
        {
          code: "missingValue",
          message: this.generateErrorMessage(
            "validationMessageRequired",
            "blank",
          ),
        },
      ],
      valid: !!this.checkboxControllers.find((field) => field.checked),
    };
  }

  public showMore() {
    this.checkboxControllers.forEach((checkbox) => {
      const classList = checkbox.element.classList;
      if (classList.contains("hideable")) {
        if (checkbox.checked) {
          classList.remove("hidden");
        } else {
          classList.toggle("hidden");
        }
      }
    });
    this.showingMore = !this.showingMore;
    this.showMoreLinkTarget.innerText = this.showingMore
      ? "Show less..."
      : "Show more...";
  }
}
